
import {
  onBeforeMount,
  onUnmounted,
  onMounted,
  ref,
  reactive,
  computed,
  inject,
  watch,
} from "vue";
import { previewResources } from '@/utils/nativeFn';
export default {
  name: 'NoteStrategy',
  emits: ['callUploadAction'],
  props: {
    firstShow: {
      type: Boolean,
      default: false,
    },
    reportDataMap: {
      type: Object,
      default: () => ({}),
    },
    progress: {
      type: Number,
      default: 0,
    },
  },
  setup(props, { emit }) {
    const $xesLog = inject("$xesLog") as any; // 埋点
    const callUploadAction = () => {
      $xesLog.track('notes_upload_button_click', {
        ...props.reportDataMap,
        event_name:'上传笔记按钮点击',
        event_type: 'click',
        button_status:1,
        button_location:'笔记攻略弹窗',
      })
      emit('callUploadAction')
    }
    let baseurl = window.location.href.split("#")[0]
    const notePicList = [
      `${baseurl}images/note_1.png`,
      `${baseurl}images/note_2.png`,
      `${baseurl}images/note_3.png`
    ]
    const firstShow = computed(() => {
      return props.firstShow
    })
    const handlePreview = (index) => {
      previewResources({
        initIndex: index,
        data: notePicList.map(item => ({
          title: '',
          type: item.indexOf('http') !== 0 ? 'uriStr' : 'urlStr',
          resource: item
        }))
      })
    }
    return {
      firstShow,
      callUploadAction,
      notePicList,
      handlePreview
    };
  },
};
